import {Component} from '@angular/core';
import {SplitterModule} from "primeng/splitter";
import {PropertiesComponent} from "../../admin/properties/properties.component";
import {ButtonModule} from 'primeng/button';
import {RightContentComponent} from "./right-content/right-content.component";

@Component({
    selector: 'app-splitted-page',
    standalone: true,
    imports: [
        SplitterModule,
        PropertiesComponent,
        ButtonModule,
        RightContentComponent,
    ],
    templateUrl: './splitted-page.component.html',
    styleUrl: './splitted-page.component.scss'
})
export class SplittedPageComponent {

    signEvent($event: string) {

    }
}
